import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  addpedingTask,
  fetchpedingTaskById,
  fetchpedingTasks,
  updatepedingTask,
} from "./thunk";

interface PedingTaskState {
  pedingTaskList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedPedingTask: any;
}

const initialState: PedingTaskState = {
  pedingTaskList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedPedingTask: null,
};

const pedingTaskSlice = createSlice({
  name: "pedingTask",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchpedingTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchpedingTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.pedingTaskList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchpedingTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch pedingTasks";
      })
      .addCase(fetchpedingTaskById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchpedingTaskById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPedingTask = action.payload;
      })
      .addCase(fetchpedingTaskById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addpedingTask.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.pedingTaskList = state.pedingTaskList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(addpedingTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add pedingTasks";
      })
      .addCase(updatepedingTask.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.pedingTaskList = state.pedingTaskList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(updatepedingTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update pedingTasks";
      });
    // .addCase(updateStatusInPkg.fulfilled, (state, action) => {
    //   if (!action.payload?.data.id) return;
    //   state.pedingTaskList = state.pedingTaskList.map((pkg) =>
    //     pkg.id === action.payload.data.id ? action.payload.data : pkg
    //   );
    // })

    // .addCase(updateStatusInPkg.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Failed to fetch pedingTasks";
    // });
  },
});

export default pedingTaskSlice.reducer;
